import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../_redux/unpaidAgentsActions';
import * as commonColumnFormatters from '../../_common/column-formatters';
import * as customColumnFormatters from '../components/column-formatters';
import {useUnpaidAgentsUIContext} from '../context/UnpaidAgentsUIContext';
import useInfiniteScrollControl from '../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../_common/components/CommonGrid/CommonGrid";

export function UnpaidAgentsTable() {
  const {formatMessage} = useIntl();
  const prefix = 'unpaidAgents-column';
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => [
    {
      accessor: 'hasLawAdvancePayment',
      Header: formatMessage({id: `${prefix}-hasLawAdvancePayment`, defaultMessage: 'Lawsuit'})
    },
    {
      accessor: 'firstName',
      Header: formatMessage({id: `${prefix}-firstName`, defaultMessage: 'First name'})
    },
    {
      accessor: 'lastName',
      Header: formatMessage({id: `${prefix}-lastName`, defaultMessage: 'Last name'})
    },
    {
      accessor: 'agentID',
      Header: formatMessage({id: `${prefix}-agentID`, defaultMessage: 'Agent ID'})
    },
    {
      accessor: 'tamalID',
      Header: formatMessage({id: `${prefix}-tamalID`, defaultMessage: 'Tamal ID'})
    },
    {
      accessor: 'phone',
      Header: formatMessage({id: `${prefix}-phone`, defaultMessage: 'Phone'})
    },
    {
      accessor: 'form101FileExists',
      Header: formatMessage({id: `${prefix}-form101FileExists`, defaultMessage: 'Form 101 exists'})
    },
    {
      accessor: 'taxAdjustmentFileExists',
      Header: formatMessage({id: `${prefix}-taxAdjustmentFileExists`, defaultMessage: 'Tax adjustment file exists'})
    },
    {
      accessor: 'link',
      Header: formatMessage({id: `${prefix}-link`, defaultMessage: 'Link'})
    },
    {
      accessor: 'sendMessage',
      Header: formatMessage({id: `${prefix}-sendMessage`, defaultMessage: 'Send message'})
    },
  ], []);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        hasLawAdvancePayment: customColumnFormatters.LawsuitColumnFormatter(item.hasLawAdvancePayment),
        firstName: commonColumnFormatters.BoldColumnFormatter(item.firstName),
        lastName: commonColumnFormatters.BoldColumnFormatter(item.lastName),
        agentID: commonColumnFormatters.BoldColumnFormatter(item.agentID),
        tamalID: commonColumnFormatters.BoldColumnFormatter(item.tamalID),
        phone: commonColumnFormatters.BoldLTRColumnFormatter(item.phone),
        form101FileExists: commonColumnFormatters.BooleanColumnFormatter(item.form101FileExists),
        taxAdjustmentFileExists: commonColumnFormatters.TaxAdjustmentExistsColumnFormatter(item),
        link: commonColumnFormatters.UnpaidAgentsLinkColumnFormatter(item.link),
        sendMessage: commonColumnFormatters.SendMessageToUnpaidAgentColumnFormatter(item),
      };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: "unpaidAgents",
    UIContext: useUnpaidAgentsUIContext(),
    getNewEntities: actions.getUnpaidAgents,
    getNextEntities: actions.getNextUnpaidAgents,
    onEntitiesChange: entities => {
      setTableRows(entities);
    },
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
      customTableStyles={'unpaid-agents-table'}
    />
  );
}
